import { _t } from "app/i18n/i18n";
import { Button } from "react-bootstrap";
import SubscriptionsBellButton from "components/Subscriptions/SubscriptionsBellButton/SubscriptionsBellButton";
import useSubscriptions from "lib/hooks/useSubscriptions/useSubscriptions";
import { getSubscriptionTagsByCategory } from "lib/hooks/useSubscriptions/getSubscriptionsByCategory";
import styles from "./SubscriptionsButton.module.scss";
import { toCategoriesAndTags } from "../../../lib/hooks/useSubscriptions/useSubscriptions.helpers";
import { useQueryParams } from "../../../lib/hooks/useQueryParams";
import { useGetPreferences } from "../../../api/preferences/useGetPreferences";
import { PUB_LANG } from "../../../redux/slices/api/initialisePreferences";
import { useGetSectorData } from "../../../pages/redesign/menuFilterBar/api/getSectorData";
import { existsHtmlFormat } from "../../../utils/publications";
import { getCoverImage, isAnchorReport } from "../../TileView/TileView";
import subHover from "../../PublicationCard/assets/icons/NaiRa_SUB_BUT_HOVER.svg";
import subOn from "../../PublicationCard/assets/icons/NaiRa_SUB_BUT_ON.svg";
import pubStyles from "../../PublicationCard/PublicationCard.module.scss";

function SubscriptionsButton({ publication, customClass, customStyle, isFromPillsBar, isFromFeaturedCard}) {
  const sectorData = useGetSectorData();
  const {
    setSelectedPub,
    setModalShow,
    setSubscriptionName,
    setIsSubscriptionFromPillsBar,
    setSelectedLanguages,
    setSelectedSubscriptionTags,
  } = useSubscriptions();
  const qs = useQueryParams();
  const categoriesAndTags = toCategoriesAndTags(qs, sectorData);
  const reportLang = useGetPreferences(PUB_LANG);
  const hasCoverImage =
    ((isAnchorReport(publication) && existsHtmlFormat(publication)) || getCoverImage(publication)) &&
    !isFromFeaturedCard;

  return (
    <button 
    className={`${pubStyles["subscribe-btn"]} ${customClass}`}
    style={customStyle}
    onClick={() => {
        setIsSubscriptionFromPillsBar(!!isFromPillsBar);
        setSelectedLanguages(reportLang);
        const pub = isFromPillsBar ? { id: "from-qs", tagsByCategory: categoriesAndTags } : publication;
        setSelectedPub(pub);
        const tags = Object.values(getSubscriptionTagsByCategory(pub)).flat();
        setSelectedSubscriptionTags(tags);
        setSubscriptionName("");
        setModalShow(true);
      }}
    >
      <img src={subHover} alt="Subscribe" className={pubStyles["btn-icon-hover"]} />
      <img src={subOn} alt="Subscribe" className={pubStyles["btn-icon-on"]} />
    </button>
 );
}

export default SubscriptionsButton;
